import { createWebHistory, createRouter, RouteRecordRaw } from 'vue-router';

import AdminDatabaseView from '@/views/Admin/AdminDatabase.vue';
import AdminView from '@/views/Admin/Admin.vue';
import AnalyticsView from '@/views/Analytics/Analytics.vue';
import AnalyticsHomeView from '@/views/Analytics/AnalyticsHome.vue';
import EntryFlowStatsTableView from '@/views/Analytics/EntryFlowStatsTable.vue';
import IdleDevicesTableView from '@/views/Analytics/IdleDevicesTable.vue';
import KpiDashboardView from '@/views/Analytics/KpiDashboard.vue';
import ProductionTrackingView from '@/views/Analytics/ProductionTracking.vue';
import OrderPerformanceView from '@/views/Analytics/OrderPerformance.vue';
import ProductionCadenceView from '@/views/Analytics/ProductionCadence.vue';
import ManagementControlTableView from '@/views/Analytics/ManagementControlTable.vue';
import AdvAltHomeView from '@/views/Processes/Adv/AdvAltHome.vue';
import BuybackView from './views/Buyback/Buyback.vue';
import BuybackHomeView from './views/Buyback/BuybackHome.vue';
import BuybackTableView from './views/Buyback/BuybackTable.vue';
import BuybackReceptionView from './views/Buyback/BuybackReception.vue';
import BuybackSkuMpConfigView from './views/Buyback/BuybackSkuMpConfig.vue';
import BuybackSettingsView from './views/Buyback/BuybackSettings.vue';
import CRMView from './views/CRM/CRM.vue';
import CustomerTableView from './views/CRM/CustomerTable.vue';
import PipelineBoardView from './views/CRM/PipelineBoard.vue';
import AdvCatalogueTableView from '@/views/Processes/Adv/AdvCatalogueTable.vue';
import AdvCommissionTableView from '@/views/Processes/Adv/AdvCommissionTable.vue';
import AdvView from '@/views/Processes/Adv/Adv.vue';
import ChangelogHomeView from '@/views/Changelog/ChangelogHome.vue';
import ChangelogView from '@/views/Changelog/Changelog.vue';
import Control1NewView from '@/views/Processes/Control/Control1New.vue';
import Control2FormView from '@/views/Processes/Control/Control2Form.vue';
import Control3ConfirmView from '@/views/Processes/Control/Control3Confirm.vue';
import ControlHomeView from '@/views/Processes/Control/ControlHome.vue';
import ControlProcessView from '@/views/Processes/Control/ControlProcess.vue';
import ControlTableView from '@/views/Processes/Control/ControlTable.vue';
import ControlView from '@/views/Processes/Control/Control.vue';
import DismantlingScanView from './views/Processes/SpecialProcess/Dismantling/DismantlingScanView.vue';
import DismantlingTaskView from './views/Processes/SpecialProcess/Dismantling/DismantlingTask.vue';
import ProductionCagesTableView from '@/views/Processes/Production/Cages/ProductionCagesTable.vue';
import GradeProcessView from '@/views/Processes/Control/Grade/GradeProcess.vue';
import GradeScanView from '@/views/Processes/Control/Grade/GradeScan.vue';
import GradeTasksView from '@/views/Processes/Control/Grade/GradeTasks.vue';
import GradeV2ProcessView from '@/views/Processes/Control/GradeV2/GradeV2Process.vue';
import GradeV2ScanView from '@/views/Processes/Control/GradeV2/GradeV2Scan.vue';
import GradeV2TasksView from '@/views/Processes/Control/GradeV2/GradeV2Tasks.vue';
import HomeView from '@/views/Home.vue';
import LoginView from '@/views/Login.vue';
import LogoutView from '@/views/Logout.vue';
import AccountingHomeView from '@/views/Processes/Accounting/AccountingHome.vue';
import AccountingInvoiceTableView from '@/views/Processes/Accounting/AccountingInvoiceTable.vue';
import AccountingTransferTableView from '@/views/Processes/Accounting/AccountingTransferTable.vue';
import AccountingExportTableView from '@/views/Processes/Accounting/AccountingExportTable.vue';
import AccountingSituationTableView from '@/views/Processes/Accounting/AccountingSituationTable.vue';
import AccountingImportTableView from '@/views/Processes/Accounting/AccountingImportTable.vue';
import AccountingBankImportTableView from '@/views/Processes/Accounting/AccountingBankImportTable.vue';
import AccountingPaymentImportsTableView from '@/views/Processes/Accounting/AccountingPaymentImportsTable.vue';
import AccountingSettingsTableView from '@/views/Processes/Accounting/AccountingSettingsTableView.vue';
import InvoiceTableView from '@/views/Processes/Accounting/InvoiceTable.vue';
import AccountingView from '@/views/Processes/Accounting/Accounting.vue';
import MatchingDepositView from '@/views/Processes/Matching/MatchingDeposit.vue';
import MatchingHomeView from '@/views/Processes/Matching/MatchingHome.vue';
import MatchingPrintLabelView from '@/views/Processes/Matching/MatchingPrintLabel.vue';
import MatchingRetrievalInfosView from './views/Processes/Matching/MatchingRetrievalInfos.vue';
import MatchingRetrievalProcessView from '@/views/Processes/Matching/MatchingRetrievalProcess.vue';
import MatchingRetrievalStartView from '@/views/Processes/Matching/MatchingRetrievalStart.vue';
import MatchingRetrievalSummaryView from '@/views/Processes/Matching/MatchingRetrievalSummary.vue';
import MatchingRetrievalView from '@/views/Processes/Matching/MatchingRetrieval.vue';
import MatchingTableView from '@/views/Processes/Matching/MatchingTable.vue';
import MatchingView from '@/views/Processes/Matching/Matching.vue';
import NavbarView from '@/views/Navbar.vue';
import Part from '@/views/Processes/SpecialProcess/Part.vue';
import PartInfosView from '@/views/Processes/SpecialProcess/PartInfosView.vue';
import PartScanView from '@/views/Processes/SpecialProcess/PartScan.vue';
import ProductionTableView from '@/views/Processes/Production/ProductionTable.vue';
import ProcessView from '@/views/Processes/SpecialProcess/SpecialProcess.vue';
import RmaProcessView from '@/views/Processes/Rma/RmaProcess.vue';
import RmaScanView from '@/views/Processes/Rma/RmaScan.vue';
import RmaTasksView from '@/views/Processes/Rma/RmaTasks.vue';
import RmaInfosView from '@/views/Processes/Rma/RmaInfos.vue';
import ProcessesHomeView from '@/views/Processes/ProcessesHome.vue';
import PurchaseOrdersMacView from '@/views/Processes/Purchase/Orders/PurchaseOrdersMac.vue';
import PurchaseReceptionsMacView from '@/views/Processes/Purchase/Receptions/PurchaseReceptionsMac.vue';
import PurchaseStocksMacView from '@/views/Processes/Purchase/Stocks/PurchaseStocksMac.vue';
import PurchaseSuppliersView from '@/views/Processes/Purchase/Suppliers/PurchaseSuppliers.vue';
import PurchaseTableView from '@/views/Processes/Purchase/PurchaseTable.vue';
import PurchaseView from '@/views/Processes/Purchase/Purchase.vue';
import SavHomeView from '@/views/Processes/Sav/SavHome.vue';
import PaymentLinksTableView from '@/views/Processes/Sav/PaymentLinksTable.vue';
import SavTableView from '@/views/Processes/Sav/SavTable.vue';
import SavView from '@/views/Processes/Sav/Sav.vue';
import SpecialProcessHome from '@/views/Processes/SpecialProcess/SpecialProcessHome.vue';
import SpecialProcessPartTableView from './views/Processes/SpecialProcess/SpecialProcessPartTable.vue';
import SpecialProcessPriorityTable from './views/Processes/SpecialProcess/SpecialProcessPriorityTable.vue';
import SubNavbarView from '@/views/SubNavbar.vue';
import TasksView from '@/views/Tasks/Tasks.vue';
import TasksHomeView from '@/views/Tasks/TasksHome.vue';
import UnpackingListView from '@/views/Processes/Control/Unpacking/UnpackingList.vue';
import UnpackingProcessView from '@/views/Processes/Control/Unpacking/UnpackingProcess.vue';
import ManagementView from './views/Management/Management.vue';
import ManagementHomeView from './views/Management/ManagementHome.vue';
import AccessRightsView from './views/AccessRights/AccessRights.vue';
import AccessRightsHomeView from './views/AccessRights/AccessRightsHome.vue';
import ProductionView from './views/Processes/Production/Production.vue';
import ProductionHomeView from './views/Processes/Production/ProductionHome.vue';
import DiagnosisRepairView from './views/Processes/Production/DiagnosisRepair/DiagnosisRepair.vue';
import DiagnosisRepairInfosView from './views/Processes/Production/DiagnosisRepair/DiagnosisRepairInfos.vue';
import DiagnosisRepairScanView from './views/Processes/Production/DiagnosisRepair/DiagnosisRepairScan.vue';
import DiagnosisRepairTaskView from './views/Processes/Production/DiagnosisRepair/DiagnosisRepairTask.vue';
import Dismantling from './views/Processes/SpecialProcess/Dismantling/Dismantling.vue';
import OrderSparePartsTableView from './views/Processes/Matching/OrderSparePartsTable.vue';
import RunnersQuestsTableView from './views/Processes/Matching/RunnersQuestsTable.vue';

const routes: RouteRecordRaw[] = [
  {
    name: 'login',
    path: '/login',
    component: LoginView
  },
  {
    path: '/',
    component: HomeView,
    redirect: { name: 'processes-home' },
    children: [
      {
        path: '',
        name: 'processes-home',
        component: ProcessesHomeView
      },
      {
        path: 'changelog',
        name: 'changelog',
        component: ChangelogView,
        redirect: { name: 'changelog-home' },
        children: [
          {
            path: '',
            name: 'changelog-home',
            components: {
              navbar: NavbarView,
              default: ChangelogHomeView
            }
          }
        ]
      },
      {
        name: 'admin',
        path: '/admin',
        component: AdminView,
        redirect: { name: 'admin-home' },
        children: [
          {
            name: 'admin-home',
            path: 'database/:adminPath*',
            components: {
              navbar: NavbarView,
              subnavbar: SubNavbarView,
              default: AdminDatabaseView
            }
          }
        ]
      },
      {
        name: 'analytics',
        path: '/analytics',
        component: AnalyticsView,
        redirect: { name: 'analytics-home' },
        children: [
          {
            name: 'analytics-home',
            path: '',
            components: {
              navbar: NavbarView,
              subnavbar: SubNavbarView,
              default: AnalyticsHomeView
            }
          },
          {
            name: 'entry-flow-stats-table',
            path: 'entry-flow-stats',
            components: {
              navbar: NavbarView,
              default: EntryFlowStatsTableView
            }
          },
          {
            name: 'idle-devices-table',
            path: 'mac-immobiles',
            components: {
              navbar: NavbarView,
              default: IdleDevicesTableView
            }
          },
          {
            name: 'management-control-table',
            path: 'controle-gestion',
            components: {
              navbar: NavbarView,
              default: ManagementControlTableView
            }
          },
          {
            name: 'kpi-dashboard',
            path: 'kpi',
            components: {
              navbar: NavbarView,
              default: KpiDashboardView
            }
          },
          {
            name: 'production-tracking',
            path: 'suivi-production',
            components: {
              navbar: NavbarView,
              default: ProductionTrackingView
            }
          },
          {
            name: 'order-performance',
            path: 'performance-commandes',
            components: {
              navbar: NavbarView,
              default: OrderPerformanceView
            }
          },
          {
            name: 'production-cadence',
            path: 'cadences-production',
            components: {
              navbar: NavbarView,
              default: ProductionCadenceView
            }
          }
        ]
      },
      {
        name: 'buyback',
        path: '/buyback',
        component: BuybackView,
        redirect: { name: 'buyback-home' },
        children: [
          {
            name: 'buyback-home',
            path: '',
            components: {
              navbar: NavbarView,
              subnavbar: SubNavbarView,
              default: BuybackHomeView
            }
          },
          {
            name: 'buyback-table',
            path: 'table',
            components: {
              navbar: NavbarView,
              default: BuybackTableView
            }
          },
          {
            name: 'buyback-reception',
            path: 'reception',
            components: {
              navbar: NavbarView,
              default: BuybackReceptionView
            }
          },
          {
            name: 'buyback-sku-mp-config',
            path: 'sku-mp-config',
            components: {
              navbar: NavbarView,
              default: BuybackSkuMpConfigView
            }
          },
          {
            name: 'buyback-settings',
            path: 'settings',
            components: {
              navbar: NavbarView,
              default: BuybackSettingsView
            }
          }
        ]
      },
      {
        name: 'crm',
        path: '/crm',
        component: CRMView,
        redirect: { name: 'customer-table' },
        children: [
          {
            name: 'customer-table',
            path: '',
            components: {
              navbar: NavbarView,
              default: CustomerTableView
            }
          },
          {
            name: 'crm-pipeline',
            path: 'pipeline',
            components: {
              navbar: NavbarView,
              default: PipelineBoardView
            }
          }
        ]
      },
      {
        name: 'tasks',
        path: '/tasks',
        component: TasksView,
        redirect: { name: 'tasks-home' },
        children: [
          {
            name: 'tasks-home',
            path: '',
            components: {
              navbar: NavbarView,
              default: TasksHomeView
            }
          }
        ]
      },
      {
        name: 'management',
        path: '/management',
        component: ManagementView,
        redirect: { name: 'management-home' },
        children: [
          {
            name: 'management-home',
            path: '',
            components: {
              navbar: NavbarView,
              subnavbar: SubNavbarView,
              default: ManagementHomeView
            }
          }
        ]
      },
      {
        name: 'access-rights',
        path: '/access-rights',
        component: AccessRightsView,
        redirect: { name: 'access-rights-home' },
        children: [
          {
            name: 'access-rights-home',
            path: '',
            components: {
              navbar: NavbarView,
              default: AccessRightsHomeView
            }
          }
        ]
      },
      {
        path: 'control',
        name: 'control',
        component: ControlView,
        redirect: { name: 'control-home' },
        children: [
          {
            path: '',
            name: 'control-home',
            components: {
              navbar: NavbarView,
              subnavbar: SubNavbarView,
              default: ControlHomeView
            }
          },
          {
            name: 'clean_control',
            path: 'clean_control',
            component: DiagnosisRepairView,
            props: {
              dor: 'clean_control'
            },
            redirect: { name: 'clean_control-scan' },
            children: [
              {
                name: 'clean_control-scan',
                path: 'scan',
                component: DiagnosisRepairScanView,
                props: {
                  dor: 'clean_control'
                }
              },
              {
                name: 'clean_control-task',
                path: ':deviceId',
                components: {
                  default: DiagnosisRepairTaskView,
                  infos: DiagnosisRepairInfosView
                },
                props: {
                  default: true
                }
              }
            ]
          },
          {
            path: 'process',
            name: 'control-process',
            component: ControlProcessView,
            redirect: { name: 'control-new' },
            children: [
              {
                path: '',
                name: 'control-new',
                component: Control1NewView
              },
              {
                path: ':controlId/form',
                name: 'control-form',
                component: Control2FormView,
                props: true
              },
              {
                path: ':serialNo/confirm',
                name: 'control-confirm',
                component: Control3ConfirmView,
                props: true
              }
            ]
          },
          {
            path: 'grading',
            name: 'grade-process',
            component: GradeProcessView,
            redirect: { name: 'grade-scan' },
            children: [
              {
                path: 'scan',
                name: 'grade-scan',
                component: GradeScanView
              },
              {
                path: ':deviceId',
                name: 'grade-tasks',
                components: {
                  default: GradeTasksView
                },
                props: {
                  default: true
                }
              }
            ]
          },
          {
            path: 'grading-v2',
            name: 'grade-v2-process',
            component: GradeV2ProcessView,
            redirect: { name: 'grade-v2-scan' },
            children: [
              {
                path: 'scan',
                name: 'grade-v2-scan',
                component: GradeV2ScanView
              },
              {
                path: ':deviceId',
                name: 'grade-v2-tasks',
                components: {
                  default: GradeV2TasksView
                },
                props: {
                  default: true
                }
              }
            ]
          },
          {
            name: 'diagnosis',
            path: 'diagnosis',
            component: DiagnosisRepairView,
            props: {
              dor: 'diagnosis'
            },
            redirect: { name: 'diagnosis-scan' },
            children: [
              {
                name: 'diagnosis-scan',
                path: 'scan',
                component: DiagnosisRepairScanView,
                props: {
                  dor: 'diagnosis'
                }
              },
              {
                name: 'diagnosis-task',
                path: ':deviceId',
                components: {
                  default: DiagnosisRepairTaskView,
                  infos: DiagnosisRepairInfosView
                },
                props: {
                  default: true
                }
              }
            ]
          },
          {
            name: 'install',
            path: 'install',
            component: DiagnosisRepairView,
            props: {
              dor: 'install'
            },
            redirect: { name: 'install-scan' },
            children: [
              {
                name: 'install-scan',
                path: 'scan',
                component: DiagnosisRepairScanView,
                props: {
                  dor: 'install'
                }
              },
              {
                name: 'install-task',
                path: ':deviceId',
                components: {
                  default: DiagnosisRepairTaskView,
                  infos: DiagnosisRepairInfosView
                },
                props: {
                  default: true
                }
              }
            ]
          },
          {
            path: 'unpacking',
            name: 'unpacking-process',
            components: { default: UnpackingProcessView },
            redirect: { name: 'unpacking-list' },
            children: [
              {
                path: 'list',
                name: 'unpacking-list',
                component: UnpackingListView
              }
            ]
          },
          {
            path: 'table',
            name: 'control-table',
            components: {
              navbar: NavbarView,
              default: ControlTableView
            }
          },
          {
            path: 'rma',
            name: 'rma-process',
            component: RmaProcessView,
            redirect: { name: 'rma-scan' },
            children: [
              {
                path: 'scan',
                name: 'rma-scan',
                component: RmaScanView
              },
              {
                path: ':serial',
                name: 'rma-tasks',
                components: {
                  default: RmaTasksView,
                  infos: RmaInfosView
                },
                props: {
                  default: true
                }
              }
            ]
          }
        ]
      },
      {
        path: 'matching',
        name: 'matching',
        component: MatchingView,
        redirect: { name: 'matching-home' },
        children: [
          {
            path: '',
            name: 'matching-home',
            components: {
              navbar: NavbarView,
              subnavbar: SubNavbarView,
              default: MatchingHomeView
            }
          },
          {
            path: 'table/:table',
            name: 'matching-table',
            components: {
              navbar: NavbarView,
              default: MatchingTableView
            },
            props: {
              default: true
            }
          },
          {
            path: 'deposit',
            name: 'matching-deposit',
            components: {
              default: MatchingDepositView
            }
          },
          {
            path: 'retrieval',
            name: 'matching-retrieval',
            component: MatchingRetrievalProcessView,
            redirect: { name: 'retrieval-start' },
            children: [
              {
                path: ':pickingId/start',
                name: 'retrieval-start',
                component: MatchingRetrievalStartView,
                props: true
              },
              {
                path: ':pickingId/process',
                name: 'retrieval-process',
                components: {
                  default: MatchingRetrievalView,
                  infos: MatchingRetrievalInfosView
                },
                props: true
              },
              {
                path: ':pickingId/summary',
                name: 'retrieval-summary',
                component: MatchingRetrievalSummaryView,
                props: true
              }
            ]
          },
          {
            path: 'print',
            name: 'matching-print',
            components: {
              default: MatchingPrintLabelView
            }
          },
          {
            path: 'order-spare-parts',
            name: 'matching-order-spare-parts',
            components: {
              navbar: NavbarView,
              default: OrderSparePartsTableView
            }
          },
          {
            path: 'runners-quests',
            name: 'matching-runners-quests',
            components: {
              navbar: NavbarView,
              default: RunnersQuestsTableView
            }
          }
        ]
      },
      {
        name: 'production',
        path: 'production',
        component: ProductionView,
        redirect: { name: 'production-home' },
        children: [
          {
            name: 'production-home',
            path: '',
            components: {
              navbar: NavbarView,
              subnavbar: SubNavbarView,
              default: ProductionHomeView
            }
          },
          {
            name: 'repair',
            path: 'repair',
            component: DiagnosisRepairView,
            props: {
              dor: 'repair'
            },
            redirect: { name: 'repair-scan' },
            children: [
              {
                name: 'repair-scan',
                path: 'scan',
                component: DiagnosisRepairScanView,
                props: {
                  dor: 'repair'
                }
              },
              {
                name: 'repair-task',
                path: ':deviceId',
                components: {
                  default: DiagnosisRepairTaskView,
                  infos: DiagnosisRepairInfosView
                },
                props: {
                  default: true
                }
              }
            ]
          },
          {
            name: 'battery',
            path: 'battery',
            component: DiagnosisRepairView,
            props: {
              dor: 'battery'
            },
            redirect: { name: 'battery-scan' },
            children: [
              {
                name: 'battery-scan',
                path: 'scan',
                component: DiagnosisRepairScanView,
                props: {
                  dor: 'battery'
                }
              },
              {
                name: 'battery-task',
                path: ':deviceId',
                components: {
                  default: DiagnosisRepairTaskView,
                  infos: DiagnosisRepairInfosView
                },
                props: {
                  default: true
                }
              }
            ]
          },
          {
            name: 'keys',
            path: 'keys',
            component: DiagnosisRepairView,
            props: {
              dor: 'keys'
            },
            redirect: { name: 'keys-scan' },
            children: [
              {
                name: 'keys-scan',
                path: 'scan',
                component: DiagnosisRepairScanView,
                props: {
                  dor: 'keys'
                }
              },
              {
                name: 'keys-task',
                path: ':deviceId',
                components: {
                  default: DiagnosisRepairTaskView,
                  infos: DiagnosisRepairInfosView
                },
                props: {
                  default: true
                }
              }
            ]
          },
          {
            name: 'quality',
            path: 'quality',
            component: DiagnosisRepairView,
            props: {
              dor: 'quality'
            },
            redirect: { name: 'quality-scan' },
            children: [
              {
                name: 'quality-scan',
                path: 'scan',
                component: DiagnosisRepairScanView,
                props: {
                  dor: 'quality'
                }
              },
              {
                name: 'quality-task',
                path: ':deviceId',
                components: {
                  default: DiagnosisRepairTaskView,
                  infos: DiagnosisRepairInfosView
                },
                props: {
                  default: true
                }
              }
            ]
          },
          {
            name: 'clean_prod',
            path: 'clean_prod',
            component: DiagnosisRepairView,
            props: {
              dor: 'clean_prod'
            },
            redirect: { name: 'clean_prod-scan' },
            children: [
              {
                name: 'clean_prod-scan',
                path: 'scan',
                component: DiagnosisRepairScanView,
                props: {
                  dor: 'clean_prod'
                }
              },
              {
                name: 'clean_prod-task',
                path: ':deviceId',
                components: {
                  default: DiagnosisRepairTaskView,
                  infos: DiagnosisRepairInfosView
                },
                props: {
                  default: true
                }
              }
            ]
          },
          {
            name: 'brief_cleaning',
            path: 'brief_cleaning',
            component: DiagnosisRepairView,
            props: {
              dor: 'brief_cleaning'
            },
            redirect: { name: 'brief_cleaning-scan' },
            children: [
              {
                name: 'brief_cleaning-scan',
                path: 'scan',
                component: DiagnosisRepairScanView,
                props: {
                  dor: 'brief_cleaning'
                }
              },
              {
                name: 'brief_cleaning-task',
                path: ':deviceId',
                components: {
                  default: DiagnosisRepairTaskView,
                  infos: DiagnosisRepairInfosView
                },
                props: {
                  default: true
                }
              }
            ]
          },
          {
            name: 'packing',
            path: 'packing',
            component: DiagnosisRepairView,
            props: {
              dor: 'packing'
            },
            redirect: { name: 'packing-scan' },
            children: [
              {
                name: 'packing-scan',
                path: 'scan',
                component: DiagnosisRepairScanView,
                props: {
                  dor: 'packing'
                }
              },
              {
                name: 'packing-task',
                path: ':deviceId',
                components: {
                  default: DiagnosisRepairTaskView,
                  infos: DiagnosisRepairInfosView
                },
                props: {
                  default: true
                }
              }
            ]
          },
          {
            name: 'production_management',
            path: 'production',
            components: {
              navbar: NavbarView,
              default: ProductionTableView
            }
          },
          {
            name: 'cage',
            path: 'cage',
            components: {
              navbar: NavbarView,
              default: ProductionCagesTableView
            }
          }
        ]
      },
      {
        name: 'purchase',
        path: '/purchase',
        component: PurchaseView,
        redirect: { name: 'purchase-table' },
        children: [
          {
            name: 'purchase-table',
            path: 'table',
            redirect: { name: 'purchase-stocks' },
            components: {
              navbar: NavbarView,
              subnavbar: SubNavbarView,
              default: PurchaseTableView
            },
            children: [
              {
                path: 'stocks',
                name: 'purchase-stocks',
                component: PurchaseStocksMacView
              },
              {
                path: 'orders',
                name: 'purchase-orders',
                component: PurchaseOrdersMacView
              },
              {
                path: 'receptions',
                name: 'purchase-receptions',
                component: PurchaseReceptionsMacView
              },
              {
                path: 'suppliers',
                name: 'purchase-suppliers',
                component: PurchaseSuppliersView
              }
            ]
          }
        ]
      },
      {
        name: 'adv',
        path: '/adv',
        component: AdvView,
        redirect: { name: 'adv-home' },
        children: [
          {
            path: '',
            name: 'adv-home',
            components: {
              navbar: NavbarView,
              subnavbar: SubNavbarView,
              default: AdvAltHomeView
            }
          },
          {
            path: 'catalogue-table',
            name: 'adv-catalogue-table',
            components: {
              navbar: NavbarView,
              default: AdvCatalogueTableView
            }
          },
          {
            path: 'commission-table',
            name: 'adv-commission-table',
            components: {
              navbar: NavbarView,
              default: AdvCommissionTableView
            }
          }
        ]
      },
      {
        name: 'sav',
        path: '/sav',
        component: SavView,
        redirect: { name: 'sav-home' },
        children: [
          {
            path: '',
            name: 'sav-home',
            components: {
              navbar: NavbarView,
              subnavbar: SubNavbarView,
              default: SavHomeView
            }
          },
          {
            path: 'table/:table',
            name: 'sav-table',
            components: {
              navbar: NavbarView,
              default: SavTableView
            },
            props: {
              default: true
            }
          },
          {
            path: 'payment-links',
            name: 'payment-links-table',
            components: {
              navbar: NavbarView,
              default: PaymentLinksTableView
            }
          }
        ]
      },
      {
        name: 'specialprocess',
        path: '/specialprocess',
        component: ProcessView,
        redirect: { name: 'process-home' },
        children: [
          {
            name: 'process-home',
            path: '',
            components: {
              navbar: NavbarView,
              subnavbar: SubNavbarView,
              default: SpecialProcessHome
            }
          },
          {
            name: 'process-repair',
            path: 'process-repair',
            component: DiagnosisRepairView,
            props: {
              dor: 'ps'
            },
            redirect: { name: 'process-repair-scan' },
            children: [
              {
                name: 'process-repair-scan',
                path: 'scan',
                component: DiagnosisRepairScanView,
                props: {
                  dor: 'ps'
                }
              },
              {
                name: 'process-repair-task',
                path: ':deviceId',
                components: {
                  default: DiagnosisRepairTaskView,
                  infos: DiagnosisRepairInfosView
                },
                props: {
                  default: true
                }
              }
            ]
          },
          {
            path: 'part',
            name: 'process-part-table',
            components: {
              navbar: NavbarView,
              default: SpecialProcessPartTableView
            },
            props: {
              default: true
            }
          },
          {
            name: 'dismantling',
            path: 'dismantling',
            component: Dismantling,
            redirect: { name: 'device-scan' },
            children: [
              {
                name: 'device-scan',
                path: 'scan',
                component: DismantlingScanView
              },
              {
                name: 'dismantling-task',
                path: ':deviceId',
                component: DismantlingTaskView
              }
            ]
          },
          {
            name: 'part-process',
            path: 'part-process',
            component: Part,
            redirect: { name: 'part-scan' },
            children: [
              {
                path: 'scan',
                name: 'part-scan',
                component: PartScanView
              },
              {
                path: ':matchId',
                name: 'part-infos',
                component: PartInfosView
              }
            ]
          },
          {
            path: 'priority-process',
            name: 'priority-process-table',
            components: {
              navbar: NavbarView,
              default: SpecialProcessPriorityTable
            },
            props: {
              default: true
            }
          }
        ]
      },
      {
        name: 'accounting',
        path: '/accounting',
        component: AccountingView,
        redirect: { name: 'home' },
        children: [
          {
            name: 'home',
            path: '',
            components: {
              navbar: NavbarView,
              subnavbar: SubNavbarView,
              default: AccountingHomeView
            }
          },
          {
            name: 'accounting-invoice',
            path: '/accounting/invoice',
            components: {
              navbar: NavbarView,
              default: AccountingInvoiceTableView
            }
          },
          {
            name: 'accounting-transfer',
            path: '/accounting/transfer',
            components: {
              navbar: NavbarView,
              default: AccountingTransferTableView
            }
          },
          {
            name: 'accounting-export',
            path: '/accounting/table',
            components: {
              navbar: NavbarView,
              default: AccountingExportTableView
            }
          },
          {
            name: 'accounting-situation',
            path: '/accounting/situation',
            components: {
              navbar: NavbarView,
              default: AccountingSituationTableView
            }
          },
          {
            name: 'accounting-invoices',
            path: '/accounting/invoices',
            components: {
              navbar: NavbarView,
              default: InvoiceTableView
            }
          },
          {
            name: 'accounting-import',
            path: '/accounting/import',
            components: {
              navbar: NavbarView,
              default: AccountingImportTableView
            }
          },
          {
            name: 'accounting-bank-imports',
            path: '/accounting/bank-imports',
            components: {
              navbar: NavbarView,
              default: AccountingBankImportTableView
            }
          },
          {
            name: 'accounting-payment-imports',
            path: '/accounting/payment-imports',
            components: {
              navbar: NavbarView,
              default: AccountingPaymentImportsTableView
            }
          },
          {
            name: 'accounting-settings',
            path: '/accounting/settings',
            components: {
              navbar: NavbarView,
              default: AccountingSettingsTableView
            }
          }
        ]
      },
      {
        name: 'logout',
        path: '/logout',
        component: LogoutView
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login'
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
